// extracted by mini-css-extract-plugin
module.exports = {"header-search-bar-suggestions-separator":"header-search-bar-suggestions-separator_header-search-bar-suggestions-separator__MHH1G"};